import styled from 'styled-components';
import Screen from '../../../../shared/utils/screen';

const DescriptionContainer = styled.div.attrs({
  id: 'descriptionContainer',
})<React.CSSProperties>`
  height: ${525 * Screen.widthRatio}px;
  left: ${96 * Screen.widthRatio}px;
  pointer-events: none;
  position: fixed;
  top: 0;
  width: 100%;
`;

export default DescriptionContainer;
